import * as React from 'react';
import { RouterLinks } from 'src/routing/routerLinks';
import { cn } from 'src/shadcn/lib/utils';
import { DashboardPageSidebar } from './DashboardPageSidebar/DashboardPageSidebar';
import { ErrorPageContainer } from 'src/Components/ErrorPage/ErrorPageContainer';
import { ErrorPageLogo } from 'src/Components/ErrorPage/ErrorPageLogo';
import { ErrorBoundary } from 'src/Components/ErrorPage/ErrorBoundary';
import {
  AppointmentsRequestContext,
  useGetAppointmentUpdates,
  useListRequestedAppointments,
} from './lib/useAppointmentsRequestContext';
import {
  ActivityFeedBadgingContext,
  useGetIsActivityFeedBadged,
} from './lib/ActivityFeedBadgingContext';
import {
  SidebarProvider,
  SidebarInset,
} from 'src/shadcn/components/ui/sidebar';

export interface IDashboardPageWithSidebarProps
  extends React.PropsWithChildren {
  currentRoute: RouterLinks;
}

export const DashboardPageWithSidebar: React.FunctionComponent<
  IDashboardPageWithSidebarProps
> = props => {
  const { requestedAppointments, isLoadingRequestedAppointments } =
    useListRequestedAppointments();
  useGetAppointmentUpdates();
  const { badgeCount } = useGetIsActivityFeedBadged();
  return (
    <ActivityFeedBadgingContext.Provider value={{ badgeCount }}>
      <AppointmentsRequestContext.Provider
        value={{ requestedAppointments, isLoadingRequestedAppointments }}
      >
        <SidebarProvider sidebarId='main'>
          <DashboardPageSidebar currentRoute={props.currentRoute} />
          <SidebarInset>
            <ErrorBoundary
              fallback={
                <div className='flex flex-1 flex-grow flex-col'>
                  <ErrorPageContainer>
                    <ErrorPageLogo />
                    <h1>
                      <span className='text-lg font-bold'>Oops!</span> An error
                      occured.
                    </h1>
                  </ErrorPageContainer>
                </div>
              }
            >
              {props.children}
            </ErrorBoundary>
          </SidebarInset>
        </SidebarProvider>
      </AppointmentsRequestContext.Provider>
    </ActivityFeedBadgingContext.Provider>
  );
};
